import { BrowserOptions } from "@sentry/react";
import * as Sentry from "@sentry/react";
import { ExcelEventSource } from "./excelEvents";

export type SentryServiceConfig = {
    options: Partial<BrowserOptions>;
}

export function initialiseSentry(config:SentryServiceConfig, appEvents:ExcelEventSource) {
    Sentry.init({
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration(),
        ],
        ...config.options
    });

    appEvents.events.userIdentified.on((payload) => {
        Sentry.setUser({
            id: payload.id,
            username: payload.username,
            email: payload.email
        });
    });

}